import { times } from "lodash";
import React from "react";

export default ({ renderValue, employeeParticulars }) => (
  <div style={{ paddingBottom: 10 }}>
    <table style={{ borderSpacing: "0px", borderCollapse: "collapse", width: "100%" }}>
      <tbody>
        <tr>
          <td
            style={{
              border: "1px solid #000",
              width: "20vw",
              padding: "0",
            }}
          >
            <table style={{ borderSpacing: "0px", borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr style={{ height: "151px" }}>
                  <td
                    style={{
                      width: "20vw",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>Signature of Employee</span>
                    <br />
                    <br />
                    <br />
                    {renderValue({
                      fieldName: "EmployeeName",
                      fieldFormat: "text",
                    })}
                    <br />
                  </td>
                </tr>
                <tr style={{ height: "30px" }}>
                  <td
                    style={{
                      width: "20vw",
                      borderTop: "1px solid #000",
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>Date: </span>
                    {renderValue({
                      fieldName: "CompletedOn",
                      fieldFormat: "date",
                      dateFormat: "DD-MM-YYYY",
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            style={{
              border: "1px solid #000",
              padding: "0",
              width: "80vw",
            }}
          >
            <table style={{ borderSpacing: "0px", borderCollapse: "collapse", width: "100%" }}>
              <tbody>
                <tr style={{ height: "30px" }}>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    <span style={{ fontWeight: "bold" }}>
                      Signature of Dependants aged 16 and above
                    </span>
                  </td>
                </tr>
                <tr style={{ height: "117px" }}>
                  {times(4, count => {
                    let dependantId = count + 1;
                    return (
                      <td
                        key={dependantId}
                        style={{
                          borderTop: "1px solid #000",
                          borderRight: "1px solid #000",
                          width: "20vw",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>
                          Signature of Dependant {dependantId}
                        </span>
                        <br />
                        <br />
                        <br />
                        {renderValue({
                          fieldName: `Dep${dependantId}Name`,
                          fieldFormat: "text",
                        })}
                        <br />
                      </td>
                    );
                  })}
                </tr>
                <tr style={{ height: "30px" }}>
                  {times(4, count => {
                    let dependantId = count + 1;
                    return (
                      <td
                        style={{
                          borderTop: "1px solid #000",
                          borderRight: "1px solid #000",
                          width: "20vw",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>Date: </span>
                        {employeeParticulars.byId &&
                          employeeParticulars.byId[`Dep${dependantId}Name`] &&
                          employeeParticulars.byId[`Dep${dependantId}Name`].fieldValue &&
                          renderValue({
                            fieldName: "CompletedOn",
                            fieldFormat: "date",
                            dateFormat: "DD-MM-YYYY",
                          })}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/SINGLIFEHD202308/Signature.js